import Highway from '@dogstudio/highway';
import { mouseMovefn } from 'utils.js';
import { getPosition } from '../utils.js';
export default class listeOffresRenderer extends Highway.Renderer {

	onEnter() {
		this.DOM = { view: this.wrap.lastElementChild };

		// this.DOM.view.querySelector('.mosaique__container').addEventListener('mousemove', mouseMovefn);

		// this.DOM.view.addEventListener('mouseleave', (e) => {
		// 	TweenMax.to(e.currentTarget.querySelectorAll('[data-mouse-parallax]'), 1.2, {x:0, y:0, ease:Power3.easeOut});
		// });

		// elements
    var formFilters = $("#formFilters");
    var selectFilters = $(".selectFilters");
    var inputFilter = $("#inputFilter");
    var locationFilter = $("#locationFilter");
    const body = document.querySelector('body');
    const menuToggle = document.querySelector('.menu__toggle');
    const filtersContainer = document.querySelector('.filters');
    const filtersHeadline = document.querySelector('#tags');
		const mapContainer = this.DOM.view.querySelector('.jobs');
		const mapJobs = this.DOM.view.querySelector('#map');
		const nextMapBlock = mapContainer.nextElementSibling;
		const pageHeader = this.DOM.view.querySelector('.Page__header');
		const jobs = this.DOM.view.querySelector('.jobs');
		this.DOM.mapContainer = mapContainer;
		this.DOM.mapJobs = mapJobs;
		// this.DOM.join__block = join__block;
		this.DOM.pageHeader = pageHeader;
		this.DOM.jobs = jobs;

		this.addEvents();
    	TweenMax.ticker.addEventListener('tick', this.visualFixed, this, true, 1);

    	let menuOpen = false;

		// map
		var map_init = false;
		var list = new Array();
		var img_marker = themeUrl+"/dist/imgs/icons/marker.png";
		var offers = [];
		var offers_default = [];
		var lat = 47.852969;
		var lon = 2.249903;
		var map = null;
		var markerClusters;
		var tile;

		// filters
		var lang = document.getElementById("lang").value;
    var tags = [];
    var type = [];
    var direction = [];
    var keyword_location = "";
		var keyword = "";

		var timerInput;
		var timerInputLocation;

		formFilters.submit(function(e) {
				e.preventDefault();
				// applyFilters();
		});

		// PRESELECTION TYPE D EVENT
		function $_GET(param) {
			var vars = {};
			window.location.href.replace( location.hash, '' ).replace(
				/[?&]+([^=&]+)=?([^&]*)?/gi, // regexp
				function( m, key, value ) { // callback
					vars[key] = value !== undefined ? value : '';
				}
			);
			if ( param ) {
				return vars[param] ? vars[param] : null;
			}
			return vars;
		}

		selectFilters.change(function(e) {
				var value = $(this).val();
				var taxo = $(this).data("taxo");

				if (tags.indexOf(value) === -1) {
						tags.push(value);
						if (taxo == "type") type.push(value)
						if (taxo == "direction") direction.push(value)
				}
				// var url = tags.join("-").toLowerCase();
				// history.pushState('', '', '/themes/' + url);
				selectFilters.find("option.defaultOption").prop('selected', true);
				applyFilters();
		});

		timerInput = false;
		inputFilter.keyup(function() {
				clearTimeout(timerInput);
				selectFilters.find("option#defaultOption").prop('selected', true);
				timerInput = setTimeout(function() {
						keyword = inputFilter.val();
						applyFilters();
				}, 500);
		});

		timerInputLocation = false;
		locationFilter.keyup(function() {
				clearTimeout(timerInputLocation);
				timerInputLocation = setTimeout(function() {
						keyword_location = locationFilter.val();
						applyFilters();
				}, 1500);
		});

		// Filters
		function applyFilters() {
				$("body").css("cursor", "wait")
				var ajaxurl = formFilters.data("ajaxurl");
				$.ajax({
						url: ajaxurl,
						type: "POST",
						data: {
								type: type,
								direction: direction,
								s: keyword,
								keyword_location: keyword_location,
								offers_default: offers_default,
								lang : lang,
						},
						success: function(data) {
								$("body").css("cursor", "default");
								data = JSON.parse(data);
								filter_offer(data);
								if (data.nb != 0) {
									charge_map(data.coordinate)
								}else {
									map.removeLayer(markerClusters);
								}
						},
						error: function() {
								$("body").css("cursor", "default")
						}
				})
		}

		function charge_map(new_coordinates = false){

			if (map_init == false) {
				map = L.map('map').setView([lat, lon], 5.5);
				tile = L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
					attribution: 'données © <a href="//osm.org/copyright">OpenStreetMap</a>/ODbL - rendu <a href="//openstreetmap.fr">OSM France</a>',
					minZoom: 5,
					maxZoom: 17,
				}).addTo(map);
				if (window.DEVMODE) console.log("init_map");
				map_init = true;
			}else {
				map.removeLayer(markerClusters);
				if (new_coordinates) {
					if (window.DEVMODE) console.log("change marker");
					offers = new_coordinates;
				}else {
					offers = offers_default;
					if (window.DEVMODE) console.log("marker default");
				}
			}
			markerClusters = L.markerClusterGroup();

			// if (window.DEVMODE) console.log(offers);
			for (var offer in offers) {
				if (offers[offer].coordinate.lat != null) {
					// if (window.DEVMODE) console.log("set marker");
					var myIcon = L.icon({
						iconUrl: img_marker,
						iconSize: [30, 30],
						iconAnchor: [30, 30],
						popupAnchor: [-5, -6],
					});
					var marker = L.marker([offers[offer].coordinate.lat, offers[offer].coordinate.lng], { icon: myIcon });
					// POPUP
					marker.bindPopup("<a href='"+ offers[offer].url +"'><h3>"+ offers[offer].title + "</h3><p class='job__detail'>"+ offers[offer].detail +"</p><p class='marker-link'>Voir l'offre</p>" +"</a>");
					markerClusters.addLayer(marker);
				}else {
					if (window.DEVMODE) console.log(offers[offer]);
				}
			}

			setTimeout(function(){
				map.addLayer(markerClusters)
				map.fitBounds(markerClusters.getBounds())
				preselect_f()
				,
				500
			})
		}

		function preselect_f(){
			var preselect_direction = $_GET('direction');
			var preselect_type = $_GET('type');
			if (preselect_direction == null && preselect_type == null) {
				return;
			}
			if (preselect_direction != null){
				preselect_direction = decodeURIComponent(preselect_direction);
				tags.push(preselect_direction);
				direction.push(preselect_direction)
			}
			if (preselect_type != null){
				preselect_type = decodeURIComponent(preselect_type);
				tags.push(preselect_type);
				type.push(preselect_type)
			}
			history.pushState({}, document.title, '/#');
			applyFilters();
		}

		function init_map(){
			var ajaxurl = $("#map").data("ajaxurl");

			$.ajax({
				url: ajaxurl,
				type: "POST",
				data: {
						lang : lang,
				},
				success: function(data) {
					data = JSON.parse(data);
					offers = data;
					offers_default = data;
					charge_map();
					filter_offer();
				},
				error: function(data) {
					if (window.DEVMODE) console.log(data);
				}
			})
		}

		init_map();

		function filter_offer(data) {
				$('#no-result').hide();
				$('.offers_list_filter_result').show();

				if (data) {
					if (data.html != 0) {
						offers = data.html;
						$(".offers_list_filter_result").html(data.html);
						$("#nb_results").text(data.nb);
					}else {
						$('#no-result').show();
						$("#nb_results").text(0);
						$('.offers_list_filter_result').hide();
					}
				}

				if (tags.length || keyword !== "" || keyword_location !== "" ) {
						$(".default_list").fadeOut();
						$(".result_list").fadeIn();

						$(".tag").remove();

						if (tags) {
								tags.forEach((tag) => {
										const tagElem = document.createElement('span');
										tagElem.className = 'tag';
										// tagElem.innerHTML = `<span>${tag}</span><a href="#" class="tag__remove"><span>supprimer</span></a>`;
										tagElem.innerHTML = `<span>${tag}</span><a href="#" class=" tag__remove"><span>supprimer</span></a>`;
										tagElem.tag = tag;

										tagElem.querySelector('.tag__remove').addEventListener('click', removeTag);
										filtersHeadline.appendChild(tagElem);
								});
						}

						var bubble = document.getElementById("searchFilter");
						if (keyword !== "") {
								if (window.DEVMODE) console.log("-- search bubble --");
								if (!bubble) {
										const tagElem = document.createElement('span');
										tagElem.className = 'tag';
										// tagElem.innerHTML = `<span id="searchFilter">${keyword}</span><a href="#" class="tag__remove"><span>supprimer</span></a>`;
										tagElem.innerHTML = `<span><span id="searchFilter">${keyword}</span><a href="#" class="tag__remove"><span>supprimer</span></a></span>`;
										tagElem.tag = keyword;
										tagElem.querySelector('.tag__remove').addEventListener('click', removeSearch);
										filtersHeadline.appendChild(tagElem);
								} else {
										bubble.innerText = keyword;
								}
						} else {
								if (bubble) bubble.remove();
						}

						var bubble_location = document.getElementById("searchFilterLocation");
						if (keyword_location !== "") {
								if (window.DEVMODE) console.log("-- search bubble_location --");
								if (!bubble_location) {
										const tagElem = document.createElement('span');
										tagElem.className = 'tag';
										// tagElem.innerHTML = `<span id="searchFilterLocation">${keyword_location}</span><a href="#" class="tag__remove"><span>supprimer</span></a>`;
										tagElem.innerHTML = `<span><span id="searchFilterLocation">${keyword_location}</span><a href="#" class="tag__remove"><span>supprimer</span></a></span>`;
										tagElem.tag = keyword_location;
										tagElem.querySelector('.tag__remove').addEventListener('click', removeSearchLocation);
										filtersHeadline.appendChild(tagElem);
								} else {
										bubble_location.innerText = keyword_location;
								}
						} else {
								if (bubble_location) bubble_location.remove();
						}

						return;

				} else {
						$(".default_list").fadeIn();
						$(".result_list").fadeOut();
						if (window.DEVMODE) console.log("-- no filter --");
						charge_map();
						return;
				}
		}

		function removeTag(e) {
				e.preventDefault();

				//Delete DOM Tag
				let item = e.currentTarget.parentNode;
				item.parentNode.removeChild(item);

				//Delete in Tags[]
				var tagIndex = tags.indexOf(item.tag);
				tags.splice(tagIndex, 1);

				var tagIndexType = type.indexOf(item.tag);
				if (tagIndexType !== -1) type.splice(tagIndexType, 1);
				var tagIndexDirection = direction.indexOf(item.tag);
				if (tagIndexDirection !== -1) direction.splice(tagIndexDirection, 1);

				if (window.DEVMODE) console.log('Tag Deleted', {
						tags
				});

				applyFilters();
		}

		function removeSearch(e) {
				e.preventDefault();

				//Delete DOM Tag
				let item = e.currentTarget.parentNode;
				item.parentNode.removeChild(item);
				//Delete in Tags[]
				keyword = "";
				inputFilter.val("");
				if (window.DEVMODE) console.log('Tag Deleted', {
						tags
				});
				applyFilters();
		}

		function removeSearchLocation(e) {
				e.preventDefault();

				//Delete DOM Tag
				let item = e.currentTarget.parentNode;
				item.parentNode.removeChild(item);
				//Delete in Tags[]
				keyword_location = "";
				locationFilter.val("");
				if (window.DEVMODE) console.log('Tag Deleted', {
						tags
				});
				applyFilters();
		}

		function restoreTags(tagsarray){
				var options = $("#selectFilters option");
				tagsarray.forEach(function(tag) {
						options.each(function() {
								var option_value = $(this).val().toLowerCase();
								if (option_value === tag) {
										tags.push($(this).val())
								}
						})
				})
				applyFilters();
		}

		// POPUP
		$('.open-apply-popup-link').magnificPopup({
			type:'inline',
			midClick: true
		});

		// GET NAME FILE
		$('.inputfile').on("change",function(){
			var file_name = $(this).val().replace(/.*[\/\\]/, '');
			$(this).siblings('.file_name').text(file_name);
			$(this).siblings('.delete_file').removeClass("hide");
		});

		// DELETE UPLOAD FILE
		$('.delete_file').on("click",function(e){
			e.preventDefault();
			$(this).siblings('.inputfile').val("");
			$(this).siblings('.file_name').text("");
			$(this).addClass("hide");
		});

		$("#send_form").on("submit",function(e){
			e.preventDefault();
			if (window.DEVMODE) console.log("-SEND-");
			$("body").css("cursor", "wait")
			$("#valid").attr("disabled", true);

		  var self = $(this);
		  var ajaxurl = self.data("ajaxurl");
			var form = document.getElementById('send_form');
		  var data = new FormData(form);
		  $.ajax({
		    type: "POST",
		    url: ajaxurl,
		    data: data,
		    contentType: false,
		    processData: false,
		    cache: false,
		    success: function(data) {
					$("#valid").attr("disabled", false);
					$("body").css("cursor", "default")
					data = JSON.parse(data);
					$("#result").text(data.message).css("color","red");
					if (data.status == true) {
						$("#form_candidate").hide();
					}
		    },
		    error: function(data) {
					$("#valid").attr("disabled", false);
					$("body").css("cursor", "default")
		    }
		   });
		 })


	}

    addEvents() {
		this.sy = 0;
		window.addEventListener('scroll', () => {
			this.sy = window.pageYOffset || document.documentElement.scrollTop;
		});
    }

    visualFixed() {


		if (window.innerWidth < 992) return;

		const start = getPosition(this.DOM.jobs).y - this.sy;
		// const end = getPosition(this.DOM.nextMapBlock).y - this.sy;
		const end = start + this.DOM.jobs.offsetHeight;
		const isFixed = start <= 0 && end >= window.innerHeight;

		// if (window.DEVMODE) console.log(isFixed, start, end, this.sy);


		// Before
		if (!isFixed && start > 0 && this.DOM.mapJobs.classList.contains('is--fixed')) {
			this.DOM.mapJobs.classList.remove('is--fixed');
		}

		// Fixed
        if (isFixed && !this.DOM.mapJobs.classList.contains('is--fixed') || this.DOM.mapJobs.classList.contains('is--btm')) {
			this.DOM.mapJobs.classList.add('is--fixed');
			this.DOM.mapJobs.classList.remove('is--btm');
        }

		// After
		if (!isFixed && end < window.innerHeight && !this.DOM.mapJobs.classList.contains('is--btm')) {
			this.DOM.mapJobs.classList.add('is--btm');
		}
    }
    onLeaveCompleted() {
        TweenMax.ticker.removeEventListener('tick', this.visualFixed);
    }
}
